export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_DROPDOWN_PAGE_SIZE = 100;
export const DEFAULT_TIME_FORMAT = "h:mm A";
export const IS_PRODUCTION = import.meta.env.VITE_ENVIRONMENT === "production";
